/** @format */

import APIRequest from "../utils/APIRequest";

export default class Cost {
  static getCostByWABAID = async (waba) => {
    return await APIRequest.set(`v1/waba/costbywabaid/${waba}`, "GET");
  };

  static addCost = async (body) => {
    return await APIRequest.set("v1/waba/addcost", "POST", body);
  };

  static updateCost = async (body, id) => {
    return await APIRequest.set(`v1/waba/updatecost/${id}`, "PUT", body);
  };
  // static getMyWaba = async () => {
  //   return await APIRequest.set("v1/waba", "GET");
  // };

  // static getCost = async (phoneNumber) => {
  //   return await APIRequest.set(
  //     `/v1/waba/costbyphonenumber/${phoneNumber}`,
  //     "GET"
  //   );
  // };

  // static getMyWabaByWABA = async (id) => {
  //   return await APIRequest.set(`v1/waba/bytenantid/${id}`, "GET");
  // };

  // static getWabaId = async (id) => {
  //   return await APIRequest.set(`v1/waba/${id}`, "GET");
  // };

  // static deleteWaba = async (id) => {
  //   return await APIRequest.set(`v1/waba/${id}`, "DELETE");
  // };
}
